import './page-section.css';

export function PageSection(props) {
    const contentIndented = props.indented ? "content-indented" : "";
    const centered = props.centered ? "centered" : "";
    const className = props.class ? props.class : "";

    return (
        <section className={`page-section ${centered} ${contentIndented} ${className}`}>
            {props.children}
        </section>
    );
}